import React, { Component } from 'react'
import DeleteCategory from 'catalog/components/DeleteCategory';
import MoveCategory from 'catalog/components/MoveCategory';
import * as categories from 'catalog/actions/categories'

import {
    Input,
    InputGroup,
    InputGroupAddon,
    Card,
    CardHeader
} from 'reactstrap'
import { connect } from 'react-redux';
import autobind from 'autobind-decorator'

@connect(
    state => ({
        activeCategory: state.categories.activeCategory,
        activeSubcategory: state.categories.activeSubcategory
    }),
    dispatch => ({
        updateCategory: (category) => dispatch(categories.updateCategory(category)),
        updateSubcategory: (subcategory) => dispatch(categories.updateSubcategory(subcategory)),
        deleteCategory: (category) => dispatch(categories.remove(category))
    })
)
export default class CategoryEdit extends Component {

    constructor(props) {
        super(props)
        const {activeCategory, activeSubcategory} = props
        this.state = {
            activeCategory,
            activeSubcategory
        }
    }

    @autobind
    changeCategoryName(e) {
        const name = e.target.value;
        const activeCategory = { ...this.props.activeCategory, name: name };
        this.setState({activeCategory})
    }

    @autobind
    changeSubcategoryName(e) {
        const name = e.target.value;
        const activeSubcategory = { ...this.props.activeSubcategory, name: name };
        this.setState({activeSubcategory})
    }

    @autobind
    updateCategory() {
        this.props.updateCategory(this.state.activeCategory);
    }

    @autobind
    updateSubcategory() {
        this.props.updateSubcategory(this.state.activeSubcategory);
    }


    render() {
        const {
            activeCategory,
            activeSubcategory
        } = this.state

        return (
            <Card>
                <CardHeader>
                    <InputGroup>
                        <Input value={activeCategory.name} onChange={this.changeCategoryName}
                            onBlur={this.updateCategory} type='textarea' />
                        <InputGroupAddon addonType='append'>
                            <DeleteCategory category={activeCategory} />
                        </InputGroupAddon>
                        <Input value={activeSubcategory.name} onChange={this.changeSubcategoryName}
                            onBlur={this.updateSubcategory} type='textarea' />
                        <InputGroupAddon addonType='append'>
                            <MoveCategory category={activeSubcategory} />
                            <DeleteCategory category={activeSubcategory} />
                        </InputGroupAddon>
                    </InputGroup>
                </CardHeader>
            </Card>)
    }
}